import React, { FunctionComponent, useEffect } from 'react';
import { withRouter } from 'react-router';
import withStyles from 'react-jss';
import { Container } from 'semantic-ui-react';
import { compose } from 'recompose';
import { Location } from 'history';
import queryString from 'query-string';
import { merge } from 'ramda';

import {
  useDatePicker,
  DatePickerState,
} from 'components/DatePicker/DatePicker.context';
import { ClassProp, WithRouterProps } from 'helpers/types';

import { ControlGroupReportsRoutes } from './scenes/ControlGroupReports';
import { PerformanceReportsRoutes } from './scenes/PerformanceReports';
import { ThirdPartyReportsRoutes } from './scenes/ThirdPartyReports';
import { CustomReportsRoutes } from './scenes/CustomReports';

type Props = WithRouterProps & {
  classes: ClassProp<typeof styles>;
  whitelistReports?: string[];
};

const styles = {
  container: {
    margin: '12.5rem 0 4rem 0 !important',
    borderRadius: '.25rem',
  },
};

const getOptions = (
  { startDate, endDate }: DatePickerState,
  { search: locationSearch, pathname }: Location,
) => {
  const searchParams = queryString.parse(locationSearch);
  const search = merge(searchParams, {
    startDate,
    endDate,
    campaignStartDate: startDate,
    campaignEndDate: endDate,
  });

  return {
    pathname,
    search: queryString.stringify(search),
  };
};

const paramsHaveChanged = (
  { startDate, endDate, defaultDateRange }: DatePickerState,
  { search }: Location,
) => {
  const { campaignStartDate, campaignEndDate }: any = queryString.parse(search);
  const sameDate =
    startDate === campaignStartDate && endDate === campaignEndDate;

  if (defaultDateRange || sameDate) {
    return false;
  }

  return true;
};

const ReportDetail: FunctionComponent<Props> = ({
  match,
  history,
  location,
  classes,
  whitelistReports,
}) => {
  const datepickerState = useDatePicker();

  useEffect(() => {
    if (paramsHaveChanged(datepickerState, location)) {
      history.push(getOptions(datepickerState, location));
    }
  }, [datepickerState]);

  const options = { whitelistReports, match };

  return (
    <Container className={classes.container}>
      <PerformanceReportsRoutes {...options} />
      <ThirdPartyReportsRoutes {...options} />
      <ControlGroupReportsRoutes {...options} />
      <CustomReportsRoutes {...options} />
    </Container>
  );
};

export default compose(withStyles(styles), withRouter)(ReportDetail as any);
